import React from 'react';
import './CoreCareerStage.css';

const CoreCareerStage = () => {
    return (
        <section className="career-section">
            <div className="career-container">
                <h2 className="career-title">Core Career Stages</h2>
                <h3 className="career-tagline">Simple Guidance for Every Step of Your Pharma Career</h3>

                <p className="career-description">
                    A successful pharma career is built step by step. Understanding your current stage helps you focus on the right skills, responsibilities, and growth opportunities.
                </p>

                <div className="career-content-block">
                    <p className="career-description">
                        <strong>1. Foundational / Entry Level:</strong> For Trainees and Junior Officers.<br />
                        Build your base with <span className="highlight-text">SOPs</span>, <span className="highlight-text">GMP</span> knowledge, technical understanding, and practical work skills.
                    </p>
                    <p className="career-description">
                        <strong>2. Core / Mid-Level:</strong> For Executives and Assistant Managers.<br />
                        Take on more responsibility by managing validations, quality systems, and small teams.
                    </p>
                    <p className="career-description">
                        <strong>3. Advanced / Senior Level:</strong> For Managers and DGMs.<br />
                        Lead departments, manage resources, improve processes, and ensure smooth operations.
                    </p>
                    <p className="career-description">
                        <strong>4. Strategic / Executive Level:</strong> For VPs and Directors.<br />
                        Drive business strategy, innovation, compliance, and long-term organizational growth.
                    </p>
                </div>

                <div className="career-content-block" style={{ marginTop: '30px' }}>
                    <p className="career-description">
                        <strong>Growth Strategies:</strong> Move ahead faster with:
                    </p>
                    <ul className="career-list" style={{ marginTop: '10px', marginLeft: '20px', listStyleType: 'disc' }}>
                        <li style={{ marginBottom: '8px' }}><span className="highlight-text">Continuous Learning</span></li>
                        <li style={{ marginBottom: '8px' }}><span className="highlight-text">Strategic Networking</span></li>
                        <li style={{ marginBottom: '8px' }}><span className="highlight-text">Skill Diversification</span></li>
                    </ul>
                </div>

                <p className="career-growth-note" style={{ marginTop: '20px', fontWeight: 'bold' }}>
                    👉 Know your stage. Build the right skills. Grow with confidence.
                </p>
            </div>
        </section>
    );
};

export default CoreCareerStage;
